const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

const pad = (value: number) => String(value).padStart(2, '0');

export function isIsoDay(value: string): boolean {
    return ISO_DAY.test(value);
}

// Local calendar day, so "today" matches the admin's wall clock rather than UTC.
export function localIsoDay(date: Date): string {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function shiftIsoDay(isoDay: string, days: number): string {
    const [year, month, day] = isoDay.split('-').map(Number);
    return localIsoDay(new Date(year, month - 1, day + days));
}
